import React, { useEffect, useState } from 'react';
import { Controller } from 'react-hook-form';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { DynamicForm, BankConfig, DeleteConfig } from '../../../../../components';

const BankProfile = ({
  photo,
  handleImgChange,
  bankData, // Data passed from parent (NewEmployee)
  onSubmit, //handleEmployeeProfileSubmit from NewEmployee
  isLoading,
  categories,
  uoms,
  onCancel, //onCancel prop from parent
  control, // control object from the parent 
  errors, // <-- `errors` comes from the parent
  reset, //  `reset` as a prop
  isReadOnly, // for view page.
  deleting  // for delete page 
}) => {
console.log('bank  data  sir.',bankData)
// Dynamically add department options to BankConfig
let updatedBankConfig; // Declare outside of the if-else block
if (deleting) {
  updatedBankConfig = DeleteConfig;
} else {
  // Dynamically populate options for UOMs and categories
  updatedBankConfig = BankConfig?.map(field => {
    // Create a copy of the field to avoid direct mutation
    let updatedField = { ...field };

    // Check if the field is for a UOM
    if (updatedField.name === 'prices_sell_uom_id' || updatedField.name === 'prices_buy_uom_id') {
      updatedField = {
        ...updatedField,
        options: [
          { value: '', label: 'Select UOM', disabled: true, hidden: true },
          ...(Array.isArray(uoms) ? uoms : []),
        ],

      };
    }
    // Check if the field is for a department (as in the original code)
    else if (updatedField.name === 'department_id') {
      updatedField = {
        ...updatedField,
        options: [
          { value: '', label: 'Select Department', disabled: true, hidden: true },
          ...(Array.isArray(categories)? categories :[]),
        ]
  
      };
    }
    return updatedField;
  });
}

//  Use useEffect to reset the form with `bankData` when it changes
useEffect(() => {
  if (bankData && reset) {
    // Create a flattened data object for react-hook-form
    reset({
      ...bankData,
      name: bankData.name,
      barcode: bankData.barcode,
      category_id: bankData.category_id,
      // Map the nested prices data to the top level for the DynamicForm
      prices_buy_uom_id: bankData.prices?.buy_uom_id,
      prices_sell_uom_id: bankData.prices?.sell_uom_id,
      // FIX: Map the new price fields
      buy_price: bankData.prices?.buy_price_new,
      sell_price: bankData.prices?.sell_price_new,
      
    });
  }
}, [bankData, reset]);
  // --- IMPORTANT: ADD THIS useEffect to log validation errors ---
  useEffect(() => {
    if (Object.keys(errors).length > 0) {
      console.error("EmployeeProfile: Validation Errors detected:", errors);
       toast.error('Please fill in all required fields.');
    }
  }, [errors]);

  // --- IMPORTANT: This function is called by react-hook-form's handleSubmit ---
  const handleFormSubmit = (dataFromForm) => {
    console.log('EmployeeProfile: handleSubmit successfully processed data:', dataFromForm);
    // This is where your actual onSubmit (handleEmployeeProfileSubmit) is called
    onSubmit(dataFromForm);
  };

  //This will call NewEmployee's handleCancel
  const handleProfileCancel = () => {if (onCancel) {onCancel(); }};

  return (
    <form onSubmit={onSubmit} className="space-y-8">
     
      {/* The rest of the fields rendered by DynamicForm */}
      <div className="md:col-span-2">
        <DynamicForm
          fields={updatedBankConfig}
          uoms={uoms}
          data={bankData}
          onSubmit={handleFormSubmit}
          isLoading={isLoading}
          control={control} // Pass shared control to DynamicForm
          onCancel={handleProfileCancel} // Pass the cancel handler to DynamicForm
          errors={errors} // <-- Pass the errors object 
          isReadOnly={isReadOnly}

            
        />
      </div>
    </form>
  );
}
export default BankProfile;
